<template>
<div>

<div class="row">
          <div class="col s4 m2"><img src="https://nl.biomedia.net/nlweb/images/sip/head2013.png" style="height:70px;"/></div>
          <div class="col s8 m10"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>
        
          <el-form ref="formBasic" :model="password" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">


    <div class="row pad-in">

    
      <div class="col s12 m6">
      <el-form-item label="Password attuale" prop="old">
        <el-input type="password" v-model="password.old"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6 clear">
      <el-form-item label="Nuova Password" prop="new">
        <el-input type="password" v-model="password.new"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6 clear">
      <el-form-item label="Reinsere Password" prop="retype">
        <el-input type="password" v-model="password.retype"></el-input>
      </el-form-item>
      </div> 

    </div>


   <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
         <div class="col s12 m3">
         <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
         </div> 
         <div class="col s12 m4 offset-m5">
         <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva</el-button>
         </div>
      </div>




  </el-form>
</div>
</template>

<script>
export default {
  name: 'contatto-password',
  data () {
      return {
        
         password:{new:'',old:'',retype:''}
         ,oldPassword: function (rule, value, callback)  {
            if(typeof value !='undefined')
            if (value.toString()!=rule.password) {
               return callback(new Error('The old password is not correct!'));
            }else{
               callback();
            }
         }
         ,retypePassword: function (rule, value, callback)  {
            if(typeof value !='undefined')
            if (value.toString()!=rule.password) {
               return callback(new Error('The new and retype password are different!'));
            }else{
               callback();
            }
         }
      }
   },
  created () {
    this.$teras.page.title = (this.$socio.contatto.row.id>0) ? 'Modifica Contatto '+this.$socio.contatto.row.id : 'Nuovo Contatto'
  },
  beforeDestroy () {
  },
  methods: {
    onChange(editor, content){
      console.log(".................................................................................:"+editor)
      //this.form.note = editor
    },
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
          this.$socio.contatto.row.password = this.password.new
          await this.$socio.contatto.save()
          this.loading.close()
          this.$router.push('/home/')




        } else {
          window.scrollTo(0,0);
          this.$notify.error({title: 'Errore',message: 'Non tutti i dati sono stati inseriti in maniera corretta, la preghiamo di verificare!'});
          return false;
        }
      })
    }

  },
  computed: {
     rules:function() {
      var rulesNow = {
        old: [
          { required: true, message: 'La vecchia password è obbligatoria' }
        ],
        new: [
          { required: true, message: 'La nuova password è obbligatoria'}
        ],
        old: [
          { required: true, validator: this.oldPassword, password:this.$socio.contatto.row.password, message: 'La vecchia password non è corretta!', trigger:"change" }
        ],
        retype: [
          { required: true, validator: this.retypePassword, password:this.password.new, message: 'La nuova password non coincide con quella di controllo!', trigger:"change" }
        ]    
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>